export const OPEN_WEATHER_API_BASE_URL = "https://api.openweathermap.org/";
export const API_KEY = "c78ce2c32c3d9ec330db2a8b597eb50a";
